import { render, staticRenderFns } from "./FormCategoryName.vue?vue&type=template&id=6e97e2a2&scoped=true&"
import script from "./FormCategoryName.vue?vue&type=script&lang=js&"
export * from "./FormCategoryName.vue?vue&type=script&lang=js&"
import style0 from "./FormCategoryName.vue?vue&type=style&index=0&id=6e97e2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97e2a2",
  null
  
)

export default component.exports